import React, {
    useEffect,
    useState,
    useCallback,
} from 'react';
import { Transition } from 'react-transition-group';
import PropTypes from 'prop-types';

import MobileSiteNav, { FILLER_ANIMATION_TIMEOUT } from 'app/views/Header/components/MobileSiteNav';
import { analyticService } from 'global/services';

import {
    handleBurgerClick as updateBurgerAndPageStylesOnClick,
} from '../../dom-utils/toggle-burger-icon';

import './landing-mobile-site-nav.scss';


const ANIMATION_TIMEOUT = 300;


export default function LandingMobileSiteNav({
    isFillerNeeded = false,
    ...restProps
}) {
    const [burgerOpenState, setBurgerOpenState] = useState('closed');
    const { pageId } = document.body.dataset;

    const handleClick = useCallback(() => {
        setTimeout(() => {
            const nextState = burgerOpenState === 'closed' ? 'open' : 'closed';
            const eventName = burgerOpenState === 'closed' ? 'Burger_Menu_Open' : 'Burger_Menu_Close';
            analyticService.push({ eventName });
            if (nextState === 'open') {
                analyticService.push({ eventName: 'Header_Click', button_name: 'Burger' });
            }
            if (pageId === 'squid-game') {
                analyticService.push({ eventName: 'Squid_game_Menu_Click' });
            }
            setBurgerOpenState(nextState);

            updateBurgerAndPageStylesOnClick(nextState);
        }, FILLER_ANIMATION_TIMEOUT);
    }, [burgerOpenState, setBurgerOpenState, pageId]);

    useEffect(() => {
        const burgerButton = document.querySelector('.js-header-burger');
        burgerButton.addEventListener('click', handleClick);

        return () => {
            burgerButton.removeEventListener('click', handleClick);
        };
    }, [handleClick]);

    return (
        <Transition
            mountOnEnter
            unmountOnExit
            timeout={ANIMATION_TIMEOUT}
            in={burgerOpenState === 'open'}
        >
            {(transitionState) => (
                <>
                    {isFillerNeeded && (
                        <div styleName={`nav-filler ${transitionState}`} />
                    )}
                    <MobileSiteNav
                        renderContext="index"
                        transitionState={transitionState}
                        onClickNavLink={handleClick}
                        {...restProps}
                    />
                </>
            )}
        </Transition>
    );
}

LandingMobileSiteNav.propTypes = {
    isFillerNeeded: PropTypes.bool,
};
